import React from 'react'
import Editor from './Editor'

export default () => (
  <div className="App">
    <Editor />
  </div>
)
